<template>
  <div id="wideportal">
    <ServiceGrid :serviceList=serviceList />
  </div>
</template>

<script>
import ServiceGrid from './components/ServiceGrid.vue'
import axios from 'axios'

export default {
  name: 'wideportal',
  data () {
    return {
      serviceListUrl : 'service_list.json',
      serviceList: null
    }
  },
  mounted () {
    axios.get(this.serviceListUrl).then(response => (this.serviceList = response.data));
  },
  components: {
    ServiceGrid
  }
}
</script>